import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { Chat } from './Chat';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { Box } from '@lifeomic/chroma-react/components/Box';
import clsx from 'clsx';
import { Divider } from '@mui/material';
import { ChatSummary } from './ChatSummary';

const messages = defineMessages({
  summary: {
    id: 'agentChat.memberChatHistory.summary',
    defaultMessage: 'Summary',
  },
  history: {
    id: 'agentChat.memberChatHistory.history',
    defaultMessage: 'History',
  },
});

const useStyles = makeStyles((theme: Theme) => ({
  panels: {
    flex: 1,
    maxHeight: '100%',
  },
  panel: {
    flex: 1,
    flexShrink: 10,
    overflowY: 'auto',
    minHeight: theme.pxToRem(200),
  },
  historyPanel: {
    flex: 3,
    paddingBottom: theme.pxToRem(48),
  },
  header: {
    background: theme.palette.common.white,
    borderBottom: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.secondary,
    letterSpacing: theme.pxToRem(1.5),
    padding: theme.spacing(0.5, 2),
    position: 'sticky',
    top: 0,
    textTransform: 'uppercase',
    zIndex: 3,
  },
  body: {
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2),
    '& p + *': {
      marginTop: theme.spacing(2),
    },
  },
  historyBody: {
    flex: 1,
    padding: theme.spacing(0, 0, 2, 0),
  },
}));

export const MemberChatHistory = ({ patient }: { patient: fhir.Patient }) => {
  const { formatMessage } = useIntl();
  const classes = useStyles({});

  return (
    <Box className={classes.panels} direction="column">
      <Box className={classes.panel} direction="column">
        <Text size="caption" weight="bold" className={classes.header}>
          {formatMessage(messages.summary)}
        </Text>
        <Box className={classes.body}>
          <ChatSummary patient={patient} />
        </Box>
      </Box>
      <Divider />
      <Box
        className={clsx(classes.panel, classes.historyPanel)}
        direction="column"
      >
        <Text size="caption" weight="bold" className={classes.header}>
          {formatMessage(messages.history)}
        </Text>
        <Box className={clsx(classes.body, classes.historyBody)}>
          <Chat patient={patient} isMemberChatHistory={true} />
        </Box>
      </Box>
    </Box>
  );
};
